import React, { useState, useEffect, useRef } from 'react';
import Pagination from 'react-js-pagination';
import {
    useGlobalFilter,
    usePagination, useRowSelect, useSortBy, useTable
} from "react-table";
import useSessionStorage from '../../../hooks/useSessionStorage';
import "./table.css";
import { sortOrderObj } from '../../../helpers/data';
import * as Toasts from '../../common/Toastify';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const { data, columns, skipPageReset, updateData, hideColumns, title,
        postJob, favorite, favoriteandUnfavorite, bestmatch, bestmatchfun, openShiftRelease,
        postjobDisable, selectCandidate, getSelectCandidate, setSelectCandidate, dontShowColumns, shiftType,
        openShiftAssignJobToCandidateRelese, groupEmailModalPopup, groupSMSModalPopup, params,
        openShiftAssignJobToCandidateMultipleRelese, teamAssignEnableBtn, handlePageSize, handlePageChange, currentPage, pageSize, totalCount, isDataNotFound, jobInfo, onSort, addMentor_RemoveMentor,sortOrderType} = props;
    //const [currentPage, setCurrentPage] = useState(1);

    const [hideColumnToggle, setHideColumnToggle] = useState(false);
    // const [sortOrderType, setSortOrderType] = useState({id:null, type:null});
    const storage = useSessionStorage();
    let selectedRows = storage.getItem("selectedRows") ? storage.getItem("selectedRows") : [];
    const [shiftOrderDisable, setShiftOrderDisable] = useState(false);
    const selectedIds = {};
    if (selectedRows) {
        selectedRows.forEach(item => {
            const index = data.findIndex(val => val.candidateId === item.candidateId);
            selectedIds[index] = true;
        })
    }

    const getRowSelectedValue = (target, rowdata, rest) => {

        if (rest?.title === "Toggle All Rows Selected") {

            if (target.checked & rest?.title === "Toggle All Rows Selected") {
                storage.setItem('selectedRows', data);
            } else if (!target.checked & rest?.title === "Toggle All Rows Selected") {
                sessionStorage.removeItem('selectedRows');
            }
            if (target.checked & rowdata) {
                selectedRows = storage.getItem("selectedRows") ? storage.getItem("selectedRows") : [];
                setSelectCandidate(true);
                selectedRows.push(rowdata);
                const unique = selectedRows.reduce((pre, cur) => {
                    if (!pre.some(val => val.candidateId === cur.candidateId)) {
                        pre.push(cur)
                    }
                    return pre;
                }, [])
                storage.setItem('selectedRows', unique);
            } else {
                selectedRows = storage.getItem("selectedRows") ? storage.getItem("selectedRows") : [];
                const filter = selectedRows.filter(item => item.candidateId !== rowdata.candidateId);
                if (filter.length === 0) {
                    setSelectCandidate(false);
                }
                storage.setItem('selectedRows', filter);
            }
        } else if (rest.title === 'Toggle Row Selected') {
            if (target.checked) {
                selectedRows = storage.getItem("selectedRows") ? storage.getItem("selectedRows") : [];
                setSelectCandidate(true);
                selectedRows.push(rowdata);
                const unique = selectedRows.reduce((pre, cur) => {
                    if (!pre.some(val => val.candidateId === cur.candidateId)) {
                        pre.push(cur)
                    }
                    return pre;
                }, [])
                storage.setItem('selectedRows', unique);
            } else {
                selectedRows = storage.getItem("selectedRows") ? storage.getItem("selectedRows") : [];
                const filter = selectedRows.filter(item => item.candidateId !== rowdata.candidateId);
                if (filter.length === 0) {
                    setSelectCandidate(false);
                }
                storage.setItem('selectedRows', filter);
            }
        }
    }


    const IndeterminateCheckbox = React.forwardRef(
        ({ indeterminate, ...rest }, ref) => {
            const defaultRef = React.useRef()
            const resolvedRef = ref || defaultRef
            React.useEffect(() => {
                resolvedRef.current.indeterminate = indeterminate
            }, [resolvedRef, indeterminate])

            return <input type="checkbox" disabled={rest.disableflag} ref={resolvedRef} {...rest} onClick={e => { getRowSelectedValue(e.target, rest?.data, rest) }} />
        }
    )

    const hooks = (hooks) => {
        favorite && hooks.visibleColumns.push(columns => [
            {
                id: 'selection',
                Header: ({ getToggleAllRowsSelectedProps }) => (
                    <div>
                        <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} disableflag={params.candidateTeamId === '0' ? true : false} />
                    </div>
                ),
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ marginLeft: '5px' }}>
                        <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} data={row?.original} disableflag={false} />
                    </div>
                ),
            },
            ...columns,
        ])
    }

    const getStoredColumn = () => {
        const value = JSON.parse(localStorage.getItem(props?.pageName));
        const login = JSON.parse(sessionStorage.getItem('login'));
        if (value && Object.keys(value).length && Array.isArray(value[login?.appUserId]) && value[login?.appUserId]?.length) {
            return value[login?.appUserId]
        } else {
            return hideColumns;
        }
    }


    const { getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows,
        state,
        setGlobalFilter,
        allColumns,
        selectedFlatRows,
        getToggleHideAllColumnsProps
    } = useTable({
        columns,
        data,
        initialState: {
            hiddenColumns: getStoredColumn(),
            selectedRowIds: selectedIds,
            dontShowColumns
        },
        autoResetPage: !skipPageReset,
        updateData
    },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        hooks
    );

    const { globalFilter, hiddenColumns } = state;

    useEffect(() => {
        if (props?.pageName && hiddenColumns) {
            const value = JSON.parse(localStorage.getItem(props?.pageName));
            const login = JSON.parse(sessionStorage.getItem('login'));
            if (value && Object.keys(value).length && Array.isArray(value[login?.appUserId]) && value[login?.appUserId]?.length) {
                const newData = {
                    ...value,
                    [login?.appUserId]: hiddenColumns
                }
                localStorage.setItem(props?.pageName, JSON.stringify(newData))

            } else if (login?.appUserId) {
                const newData = {
                    ...value ?? '',
                    [login?.appUserId]: hiddenColumns
                }
                localStorage.setItem(props?.pageName, JSON.stringify(newData))
            }

        }
    }, [hiddenColumns, props])
    const scrollHorizantalRef = useRef(null);
    const intervalRef = useRef(null);
    const handleHorizantalScroll = (element, speed, distance, step) => {
        // let scrollAmount = 0;
        intervalRef.current = setInterval(() => {
          element.scrollLeft += step;
        //   scrollAmount += Math.abs(step);
        //   if (scrollAmount >= distance) {
        //     clearInterval(slideTimer);
        //   }
        }, speed);
      };
      const startScrolling = (element, speed, distance, step) => {
        handleHorizantalScroll(element, speed, distance, step)
      };
      const stopScrolling  = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      const sortHandler = (sortType, column) => {
        onSort(sortType, column?.id)
        // setSortOrderType(prev => ({...prev,id:column?.id,type:sortType}))
      };

      const selectedCandidateLabel = () => {
            if (selectedRows?.length === 0) {
                Toasts.info('Please Select the Candidates');
            }
      }

        return (
        <div className="card">
            <div className="card-header">
                <div className="col-lg-4 col-md-4">
                    <h4 className="card-title">
                        {title}
                    </h4>
                </div>
            </div>
            <div className="card-body">
                {data && data.length ?
                    <div>
                        <div id="myTable_wrapper" className="dataTables_wrapper no-footer">
                            <div className="dataTables_length" id="myTable_length"><label>Show
                                <select name="myTable_length" aria-controls="myTable" value={pageSize} onChange={(e) => handlePageSize(Number(e.target.value))}>
                                    {[10, 25, 50, 100].map((item) => (
                                        <option key={item} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select> entries</label> |
                                {bestmatch && <label className='ms-2'><input type='checkbox' value={props.IsBestMatch} checked={props.IsBestMatch} onChange={(e) => { bestmatchfun(e.target) }} /> Best Match</label>}
                                <div id="myTable_filter" className="pull-right">
                                    <label>
                                        Search:
                                        <input className="form-control searchInput" placeholder="Search for results..." value={globalFilter || ''}
                                            onChange={e => setGlobalFilter(e.target.value)}
                                            aria-controls="myTable" />
                                    </label>
                                    <span className='togglecolumnhead'>
                                        <button className="btn btn-primary btn-sm" type="button"
                                            onClick={() => setHideColumnToggle(!hideColumnToggle)}>Toggle Columns</button>
                                        {hideColumnToggle &&
                                            <>
                                                <div className='toggleColumn'>
                                                    <div>
                                                        <IndeterminateCheckbox disableflag={true} {...getToggleHideAllColumnsProps()} /> Toggle
                                                        All
                                                    </div>
                                                    {allColumns.map(column => (
                                                        !dontShowColumns.includes(column.Header) &&
                                                        <div key={column.id}>
                                                            <label className='d-flex align-items-center'>
                                                                <input type="checkbox" {...column.getToggleHiddenProps()} />{' '}
                                                                {column?.id === "selection" && <input type="checkbox" disabled={true} value={false} />}
                                                                <div className='d-flex'> {column.Header}</div>
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        }

                                        <button
                                         onMouseDown={() => startScrolling(scrollHorizantalRef.current,10, 100, -25)}
                                         onMouseLeave={stopScrolling}
                                         onMouseUp={stopScrolling}
                                            // onClick={() => handleHorizantalScroll(scrollHorizantalRef.current,10, 100, -15)}
                                            className="btn btn-primary btn-sm ms-2"
                                            type="button"
                                        >
                                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                                        </button>
                                        <button
                                         onMouseDown={() => startScrolling(scrollHorizantalRef.current,10, 100, 25)}
                                         onMouseLeave={stopScrolling}
                                         onMouseUp={stopScrolling}
                                            // onClick={() => handleHorizantalScroll(scrollHorizantalRef.current,10, 100, 15)}
                                            className="btn btn-primary btn-sm ms-2"
                                            type="button"
                                        >
                                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                                        </button>
                                        <br />
                                    </span>
                                </div>
                            </div>
                            <div className='clearfix' />
                            <div style={{maxHeight:"630px", overflow:"auto"}}  ref={scrollHorizantalRef} className="table-scrollable">
                                <table
                                    {...getTableProps()}
                                    id="myTable" className="table dataTable no-footer girdtable scrollme" role="grid" aria-describedby="myTable_info">
                                    <thead style={{position:"sticky", top:0, background:"#fff", zIndex:1}}>
                                        {headerGroups.map((headerGroup) => (
                                            <tr {...headerGroup.getHeaderGroupProps()} role="row">
                                                {headerGroup.headers.map((column, index) => {
                                                    let hideSortByToolTip ={ ...column.getHeaderProps(column.getSortByToggleProps()),title:""}
                                                    return(
                                                        <th className='reset_start header-bg-border ' title='' {...hideSortByToolTip} tabIndex="0" aria-controls="myTable"
                                                        rowSpan="1" colSpan="1">
                                                        <div className='d-flex gap-2' style={{ height: "40px", maxWidth:column?.maxWidth ?? '' }}>
                                                            <div style={{fontSize:"0.85rem"}} className='text-capitalize header_label_table'  title={headerGroup.headers[index].tipText ? (headerGroup.headers[index].tipText): ""} > {column.render("Header")}</div>
                                                            {
                                                                !column.disableSortBy
                                                                &&
                                                                <div style={{display:"flex", fontWeight:"bold",marginTop:"0.2rem"}}>

                                                                    {column?.id === sortOrderType.id &&
                                                                    sortOrderType.type === sortOrderObj.upArrow ? null : (
                                                                <i className='fa fa-arrow-up' onClick={() => sortHandler(sortOrderObj.upArrow, column)} title=''>  </i>)}
                                                                {
                                                                    (column?.id === sortOrderType.id && sortOrderType.type === sortOrderObj.downArrow) ?  null :(
                                                                        <i className='fa fa-arrow-down' onClick={() => sortHandler(sortOrderObj.downArrow, column)}   title=''>  </i>
                                                                    )
                                                                }
                                                                <i  className='fa fa-close' onClick={() => sortHandler(sortOrderObj.clearFilter, column)}  title=''>  </i>
                                                            </div>
                                                            }
                                                        </div>
                                                    </th>
                                                    )
                                                    })}
                                            </tr>
                                        ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()}>
                                        {rows.map((row) => {
                                            prepareRow(row);
                                            return (
                                                <tr {...row.getRowProps()} role="row" className="odd">
                                                    {row.cells.map((cell) => {
                                                        return (
                                                            <td className='reset_start' {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                          
                            <div className='mb-2 d-flex justify-content-between gap-2'>
                            <div style={{gap: '85px'}} className="dataTables_info mb-2 d-flex" id="myTable_info" role="status" aria-live="polite">
                                <span className='mt-2'>
                                <strong>Showing Page{" "}
                                    {currentPage} of {Math.ceil(totalCount / pageSize)}
                                </strong>
                                </span>
                                <div>
                                {
                                favorite && <>
                                    <span className='ms-4'><button onClick={() => { favoriteandUnfavorite(selectedRows, true) }}><i class="fa fa-solid fa-star"></i> Add Favorite</button></span>
                                    <span className='ms-4'><button onClick={() => { favoriteandUnfavorite(selectedRows, false) }}><i class="bi bi-star"></i>  Remove Favorite</button></span>
                                </>
                                }
                                </div>
                            </div>
                                <div className='pull-left mt-2'>
                                    <Pagination
                                        itemClass="page-item" // add it for bootstrap 4
                                        linkClass="page-link" // add it for bootstrap 4
                                        activePage={currentPage}
                                        itemsCountPerPage={pageSize}
                                        totalItemsCount={totalCount}
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange}
                                    />
                                </div>

                            </div>
                            <button onClick={() => { groupSMSModalPopup(selectedRows) }}>Group Sms</button>
                            <button className='ms-4' onClick={() => { groupEmailModalPopup(selectedRows) }}>Group Email</button>
                           
                           
                           
                           
                            {
                                favorite && <>
                                <span className='ms-4'> <button 
                                onClick={() => { addMentor_RemoveMentor(selectedFlatRows.map(item => item?.original), true) }}
                                >
                                <span className='d-flex gap-2'>
                                <span>
                                <svg width="15" height="15" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                                <polygon points="10,190 10,10 60,10 100,90 140,10 190,10 190,190 150,190 150,60 100,140 50,60 50,190" fill="white" stroke="black" stroke-width="10"/>
                                </svg>
                                </span>
                                     <span>Add Mentor</span>
                                     </span>
                                </button>
                                </span>
                                    <span className='ms-4'>
                                    <button className='' 
                                    onClick={() => { addMentor_RemoveMentor(selectedFlatRows.map(item => item?.original), false) }}
                                    >
                                <span className='d-flex gap-2'>
                                <span>
                                <svg width="15" height="15" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                                <polygon points="10,190 10,10 60,10 100,90 140,10 190,10 190,190 150,190 150,60 100,140 50,60 50,190" fill="none" stroke="white" stroke-width="10"/>
                                </svg>
                                </span>
                                   <span> Remove Mentor</span>
                                    </span>
                                </button>
                                        </span>
                                </>
                            }

                            {/* {postJob && <div className='pull-right'>
                                <div className="btn-group me-2 sw-btn-group" role="group">
                                    <button className="btn btn-primary sw-btn-next" type="button" onClick={() => postJob(selectedRows)} disabled={postjobDisable}>Post Job</button></div>
                            </div>} */}

                            {shiftType === 2 ?
                                (
                                    openShiftAssignJobToCandidateRelese && <div className='pull-right'>
                                        <div className="btn-group me-2 sw-btn-group" role="group">
                                            <button className="btn btn-primary sw-btn-next" type="button" onClick={() => openShiftAssignJobToCandidateRelese()}
                                                disabled={params.candidateTeamId === '0' ? false : true}
                                            >Assign</button>
                                        </div>
                                    </div>
                                ) : (openShiftRelease && <div className='pull-right'>
                                    <div className=" d-flex gap-2">

                                        {params.candidateTeamId === '0' ?
                                            <button type="button" onClick={() => openShiftRelease()} disabled={selectCandidate}>Select Posting Priority</button> :

                                            <button type="button" onClick={() => openShiftRelease()} disabled={params.candidateTeamId === '0' ? false : true}>Select Posting Priority</button>
                                        }

                                        <button type="button" onClick={() => openShiftAssignJobToCandidateRelese()}
                                            disabled={params.candidateTeamId === '0' ? false : true}
                                        >Assign</button>

                                        <button type="button"
                                            disabled={params.candidateTeamId === '0' ? true : false || jobInfo?.isMultiShiftMultiLocation}
                                            onClick={() => openShiftAssignJobToCandidateMultipleRelese()}
                                        >Team Assign</button>


                                    </div>
                                </div>)
                            }
                            {
                                <div className='pull-right me-4 mt-3'>
                                    {
                                        shiftType === 2 ? ("") : (<div>
                                            <div>
                                                <input className="form-check-input" value={selectCandidate} checked={selectCandidate} disabled={selectCandidate} name={'authorizedUser'} type="checkbox" onChange={(event) => { getSelectCandidate(event.target) }} />
                                            </div>
                                            <label className="form-check-label" style={{ float: 'left' }} htmlFor="flexSwitchCheckDefault" onClick={selectedCandidateLabel}>To select candidates</label>
                                        </div>)
                                    }
                                </div>
                            }
                            {/* {
                                openShiftRelease && <div className='pull-right'>
                                    <div className="btn-group me-2 sw-btn-group d-flex gap-2" role="group">
                                        <button className="btn btn-primary sw-btn-next" type="button" onClick={() => openShiftRelease()} disabled={shiftOrderDisable}>Select Posting Priority</button>
                                    </div>
                                </div>
                            }
                            {
                                <div className='pull-right me-4 mt-3'>
                                    <div>
                                        <div>
                                            <input className="form-check-input" value={selectCandidate} checked={selectCandidate} name={'authorizedUser'} type="checkbox" onChange={(event) => { getSelectCandidate(event.target) }} />
                                        </div>
                                        <label className="form-check-label" style={{ float: 'left' }} htmlFor="flexSwitchCheckDefault">To select candidates</label>
                                    </div>
                                </div>
                            } */}
                        </div>
                    </div>
                    :  (isDataNotFound && data?.length === 0) ? <div className="text-center"><h3>No Matching Search Results Found!</h3></div> : <div className="text-center"><h3>Pending Search Results !</h3></div>
                }
            </div>
        </div>
    )
}
